import React, { ReactNode } from "react";
import Layout from "@insightfulscience/atomic-react/Layout";
import SiteFooter from "../SiteFooter";
import SiteHeader from "../SiteHeader";

type Props = {
	children: ReactNode | ReactNode[];
	bodyClassName?: string;
	showTopBar?: boolean;
	hero?: boolean;
};

const SiteLayoutPure = ({ bodyClassName = "", children, ...props }: Props) => {
	return (
		<Layout isWrapper>
			<Layout.Header>
				<SiteHeader {...props} />
			</Layout.Header>
			<Layout.Body className={bodyClassName}>{children}</Layout.Body>
			<Layout.Footer>
				<SiteFooter />
			</Layout.Footer>
		</Layout>
	);
};

const SiteLayout = (props: Props) => {
	return <SiteLayoutPure {...props} />;
};

SiteLayout.Pure = SiteLayoutPure;

export default SiteLayout;
